
import axios from 'axios';

export async function logActivity(menu, type) {
  if (localStorage.access_token) {
    try {
      await axios({
        method: 'post',
        url: process.env.VUE_APP_BACKEND_URL_VERSION + 'log/activity/create',
        data: {
          menu: menu,
          type: type,
        },
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        }
      });
    } catch (error) {
      console.error('Error logging activity:', error);
    }
  }
}
